module.exports = __webpack_public_path__ + "media/img/symbolic-archways-bahrain-fort-qal-al-bahrain-manama-bahrain-300edccf98c82c0ff857b86a0b3bbb0d.jpg";